export interface PublicShareApiRequest {
    share_id?: string;
    task_id?: string;
}
export interface PublicShareApiResponse {
    /**
     * 是否是分享页面`
     */
    public_share: boolean;
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 任务类型
     */
    task_type: string;
    /**
     * 是否是拥有者
     */
    owner: boolean;
}

export const PublicShareApi = Symbol('PublicShareApi');

export interface PublicShareApi {
    getShareInit(data: PublicShareApiRequest): Promise<PublicShareApiResponse>;
}
